import { Injectable } from '@angular/core';
import { FeatureTogglesClientFactory } from '../services/feature-toggles-client-factory.service';
import { FeatureTogglesClient } from '@purecloud/feature-toggles-client';
import { FeatureToggles, FeatureToggleValues } from '../model/feature-toggles.model';

@Injectable({
  providedIn: 'root'
})
export class FeatureTogglesService {
  private client: FeatureTogglesClient;

  constructor(private clientFactory: FeatureTogglesClientFactory) {
  }

  async loadAllFeatureToggles(): Promise<FeatureToggleValues> {
    return (await this.getClient()).checkToggles(Object.values(FeatureToggles));
  }

  private async getClient(): Promise<FeatureTogglesClient> {
    if (this.client) {
      return this.client;
    }

    return this.client = await this.clientFactory.createFeatureTogglesClient();
  }
}
